import moment from "moment-timezone";
import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { patch, post } from "redux/fetch";
import { rollbarXHRError } from "lib/rollbar";
import { AUTH_ERROR, LOGIN_LEVEL } from "lib/constants";
import authComponents from "js/components/auth";

import { uiSetSubmitting } from "redux/ws/actions";
import util from "js/util";
import {
    authPostStart,
    authPostSuccess,
    authPostError,
    authPostFinish,
    authWorkforceSignUp,
    authUpdatePortalUser,
} from "./actions";

const AUTH_ERROR_MAP = {
    "First name is required": AUTH_ERROR.FIRST_NAME_REQUIRED,
    "Last name is required": AUTH_ERROR.LAST_NAME_REQUIRED,
    "Invalid phone number": AUTH_ERROR.INVALID_PHONE,
    "Phone number already taken": AUTH_ERROR.PHONE_TAKEN,
    "Invalid email address": AUTH_ERROR.INVALID_EMAIL,
    "Email already taken": AUTH_ERROR.EMAIL_TAKEN,
    "Password must be at least 8 characters": AUTH_ERROR.PASSWORD_LENGTH,
    "Password must contain both letters and numbers": AUTH_ERROR.PASSWORD_STRENGTH,
    INVALID_HANDLE: AUTH_ERROR.INVALID_HANDLE,
    DUPLICATE_USER: AUTH_ERROR.DUPLICATE_USER,
};

function* runWorkforceSignUp({ payload }) {
    yield put(uiSetSubmitting(true));
    yield put(authPostStart());

    const data = { ...payload };
    data.csrf_token = yield select((state) => state.ws.csrfToken);
    data.timezone = moment.tz.guess();

    try {
        const result = yield call(post, "/api/hire/v1/workforce/signup/", data);
        yield put(authPostSuccess(result));

        if (result.redirect) {
            setTimeout(() => {
                window.location.href = result.redirect;
            }, 0);
        }
    } catch (e) {
        if (e.response.status >= 500) {
            rollbarXHRError("Workforce signup failed", e);
        }

        let error;
        if (e.json) {
            error = AUTH_ERROR_MAP[e.json.error];
        }

        if (!error) {
            error = AUTH_ERROR.UNKNOWN;
        }

        if (error === AUTH_ERROR.EMAIL_TAKEN || error === AUTH_ERROR.DUPLICATE_USER) {
            new authComponents.AuthComponent({
                // This will redirect them to their survey
                redirect: window.location.pathname,
                email: data.email,
                level: LOGIN_LEVEL.NORMAL,
            }).render();

            return;
        }

        // @TODO specific handling of signup errors
        yield put(
            authPostError({
                error,
                status: e.response.status,
            }),
        );
    } finally {
        yield put(authPostFinish());
        yield put(uiSetSubmitting(false));
    }
}

/**
 * Used on the portal account page to update the user's account.
 */
function* updatePortalUser({ payload: { user, emailSettings, handleError, csrfToken } }) {
    yield put(uiSetSubmitting(true));

    try {
        yield call(patch, "/api/hire/v1/auth/", { ...user, csrf_token: csrfToken });
        yield call(patch, "/api/hire/v1/email/settings/", {
            ...emailSettings,
            csrf_token: csrfToken,
        });
        util.showToast();
    } catch (e) {
        const error = e.message;
        if (error.toLowerCase().indexOf("email") > -1) {
            handleError("email", error);
        }
    } finally {
        yield put(uiSetSubmitting(false));
    }
}

export default function* authSagas() {
    yield all([
        takeEvery(authWorkforceSignUp, runWorkforceSignUp),
        takeEvery(authUpdatePortalUser, updatePortalUser),
    ]);
}
